export enum CallerType {
  Pstn = 'Pstn',
  Guid = 'Guid',
  Encrypted = 'Encrypted',
  AcsUser = 'AcsUser',
}
